function productSearchCompletion(formInput) {
    var searchBox = $(formInput);

    var changeTimeout;

    searchBox.on('input', function() {
        var val = $(this).val();
        var query;

        if (val) {
            clearTimeout(changeTimeout);
            if (query) {
                query.abort();
            }

            changeTimeout = setTimeout(function() {
                query = $.get(
                    Routing.generate('app_product_search_completion'), {
                        q: val
                    },
                    function(data) {
                        $('.autocomplete-modal').html(data);
                    }
                );
            }, 500);
        }
    });
}
